'use client'
import {useState} from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import HeroLayoutWithImage from 'v1/common-components/hero-layout-with-image/HeroLayoutWithImage'
import {heroData} from 'v1/content/zenhr-page'
import Button from 'v1/common-components/button/Button'
import Modal from 'v1/common-components/modal/Modal'
import BookDemoForm from 'v1/page-components/marketing/common/demo-form/BookDemoForm'
import ArrowRightIcon from 'v1/assets/icons/workflow-automation/caret-right.svg'
import classes from './styles.module.css'

export default function Hero() {
  const [isModalOpen, setModalOpen] = useState(false)

  const toggleModal = () => setModalOpen(prev => !prev)

  return (
    <>
      <HeroLayoutWithImage
        ImageSrc={heroData.image}
        heroContainerClass={classes.heroContainer}
        leftTextBox={
          <div className={classes.topLeftText}>
            <h1 className={clsx('h2-v1', classes.title)}>{heroData.title}</h1>
            <p className={classes.topParaTextContainer}>
              <p className={clsx('h5-v1', classes.colorP50)}>{heroData.subTitle}</p>
              <p className={clsx('paragraph1-v1')}>{heroData.paragraph}</p>
            </p>
            <div className={classes.actions}>
              <Button
                onClick={toggleModal}
                text={heroData.btnText}
                isAnimate={true}
                className={classes.startTrialBtn}
                iconRight={
                  <span className={classes.btnIconBox}>
                    <Image
                      loading="lazy"
                      src={ArrowRightIcon}
                      alt="login-icon"
                      width={24}
                      height={24}
                    />
                  </span>
                }
              />
            </div>
          </div>
        }
      />
      <Modal isOpen={isModalOpen} onClose={toggleModal}>
        <BookDemoForm
          data={{
            isNameRequired: true,
            heading: 'Book a demo',
            buttonText: 'Book a demo',
          }}
        />
      </Modal>
    </>
  )
}
